 /*=========================================================================================
  File Name: actions.js
  Description: Opening Hours Actions
  ----------------------------------------------------------------------------------------
  Item Name: Opening Hours State Module
  Author: Tan Tran
==========================================================================================*/
import commands from '../../../services/openingHours/commands.js'
import queries from '../../../services/openingHours/queries.js'
import TimeFormatter from '../../../common/utils/TimeFormatter.js';
import ErrorHandling from '../../../common/exceptions/ErrorHandling.js'

export default {

    async getOpeningHoursTableAction ( { commit, state, rootState }, payload) {

        let restaurantId = rootState.auth.auth.restaurantId;
        let error = null;
        try {
            await queries.getOpeningTimesByRestaurant(restaurantId)
                     .then(
                         res => {
                             commit('SET_OPENINGTIMESTABLE_STATE', res);
                        });
        }
        catch (err) {
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
        
    },

    async updateOpeningHourTableAction ( { commit, state, rootState }, payload ) {

        let restaurantId = rootState.auth.auth.restaurantId;
        let token = rootState.auth.auth.token;
        let error = null;
        let openingTimeToServer = {
            fromTime : TimeFormatter.timeToString(payload.data.fromTime),
            toTime : TimeFormatter.timeToString(payload.data.toTime),
            canOrderFrom : TimeFormatter.timeToString(payload.data.canOrderFrom),
            cannotOrderFrom : TimeFormatter.timeToString(payload.data.cannotOrderFrom),
            isOpened : payload.data.isOpened,
            offTime : TimeFormatter.timeToString(payload.data.offTime),
            minWaitingTime : payload.data.minWaitingTime,
            maxWaitingTime : payload.data.maxWaitingTime,
            capacity : payload.data.capacity,
            increaseTimeStep : payload.data.increaseTimeStep,
            initTimeOfOrder : payload.data.initTimeOfOrder,
            pendingOrderIncreaseStep : payload.data.pendingOrderIncreaseStep,
            label : payload.label
        };
        

        try {
            await commands.updateOpeningTime(restaurantId, payload.label, openingTimeToServer, token)
                        .then( res => {
                            commit('UPDATE_OPENINGTIME_STATE', payload);
                        });
        }
        catch (err) {
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
        
        
    },

    async getCurrentLocalTimeAction ( { commit, state, rootState}, payload) {
        let error = null;
        try {
            await queries.getCurrentLocalTime().then(data => {
                commit("SET_CURRENT_LOCAL_TIME_STATE", data);
            });
        }
        catch (err) {
            console.log(err)
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
        
    },

    async getCurrentOpeningTimeAction( { commit, state, rootState }, payload) {

        let restaurantId = rootState.auth.auth.restaurantId;
        let error = null;
        try {
            await queries.getCurrentOpeningHoursByRestaurant(restaurantId)
                    .then(data => {
                        commit('SET_CURRENT_OPENING_HOURS_STATE', data)
                    });
        }
        catch (err) {
            console.log(err)
            error = ErrorHandling.getErrorType(err);
            commit('app/SET_EXCEPTION_STATE', error, { root : true });
        }
        
    }
}